<template>
    <div>
        <form-repeater
            :repeats="repeats"
            :add="$t(`forms.professional_info.${translationPropertyName}_repeater.add`)"
            :remove="$t(`forms.professional_info.${translationPropertyName}_repeater.remove`)"
            :isDisabled="isDisabled"
            :showRemoveFromIndex="numberOfSavedItems"
            @add="addRepeat()"
            @remove="removeRepeat($event)"
        >
            <template #heading="{ index }">
                {{ $t(`forms.professional_info.${translationPropertyName}_repeater.heading`, { index: index + 1 }) }}
            </template>

            <template #default="{ data, index }">
                <form-wrapper class="form__fields" :isSubmittable="false">
                    <form-row align="bottom">
                        <form-cell v-if="data.id" width="half">
                            <form-info-field
                                :removeButtonText="$t(`forms.professional_info.${translationPropertyName}.delete`)"
                                :index="index"
                                :text="data.name"
                                :formRepeater="true"
                                @remove="openRemoveProfessionalInfoModal(index, $event)"
                            ></form-info-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                :label="$t(`forms.professional_info.${translationPropertyName}.label`)"
                                :placeholder="$t(`forms.professional_info.${translationPropertyName}.placeholder`)"
                                :isDisabled="isDisabled"
                                :formData="data"
                                :errorPath="valuePathField(index, 'name')"
                                :valuePath="valuePathField(index, 'name')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell>
                            <text-field
                                :label="$t(`forms.professional_info.city.label`)"
                                :placeholder="$t(`forms.professional_info.city.placeholder`)"
                                :isDisabled="isDisabled"
                                :formData="data"
                                :errorPath="valuePathField(index, 'city')"
                                :valuePath="valuePathField(index, 'city')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                        <form-cell>
                            <select-field
                                :label="$t(`forms.professional_info.state.label`)"
                                :placeholder="$t(`forms.professional_info.state.placeholder`)"
                                :options="states"
                                :isDisabled="isDisabled"
                                :formData="data"
                                :isRequired="false"
                                :errorPath="valuePathField(index, 'state')"
                                :valuePath="valuePathField(index, 'state')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></select-field>
                        </form-cell>
                    </form-row>
                </form-wrapper>
            </template>
        </form-repeater>
        <remove-professional-info-modal
            :isOpen="isRemoveProfessionalInfoModalOpen"
            :index="indexToBeRemoved"
            :name="propertyName"
            @close="closeRemoveProfessionalInfoModal"
            @info-removed="professionalInfoRemoved"
        ></remove-professional-info-modal>
    </div>
</template>

<script>
    import FormFragmentMixin from 'mixins/FormFragmentMixin'
    import FormRepeaterMixin from 'mixins/FormRepeaterMixin'
    import RemoveProfessionalInfoModal from 'components/page-elements/profile/RemoveProfessionalInfoModal.vue'

    export default {
        mixins: [FormFragmentMixin, FormRepeaterMixin],
        components: { RemoveProfessionalInfoModal },

        props: {
            states: { type: Array, required: true },
            propertyName: { type: String, required: true },
            translationPropertyName: { type: String, required: true },
            showRemoveProfessionalInfoModal: { type: Boolean, default: false },
        },
        data() {
            return {
                isRemoveProfessionalInfoModalOpen: false,
                indexToBeRemoved: 0,
            }
        },
        computed: {
            numberOfSavedItems() {
                return (this.repeats && this.repeats.filter((rep) => !!rep.id).length) || 0
            },
        },
        methods: {
            openRemoveProfessionalInfoModal(index) {
                this.indexToBeRemoved = index
                this.isRemoveProfessionalInfoModalOpen = true
            },

            closeRemoveProfessionalInfoModal() {
                this.isRemoveProfessionalInfoModalOpen = false
            },
            professionalInfoRemoved(payload) {
                this.closeRemoveProfessionalInfoModal()
                this.removeRepeat(payload)
            },
        },
    }
</script>
